import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'
import { mayOpenAdminPage } from '../../shared/alumni'

import AdminSupporters from '../../components/views/admin/Supporters'
import SupportersList from '../../components/views/common/SupportersList'

/**
 * Eine Route, zwei Sichten.
 *
 * Admins verwalten alle Unterstuetzer:innen inklusive Jury und Trainer:innen.
 * Lehrkraefte und Schueler:innen sehen ausschliesslich Wirtschaftsexpert:innen -
 * die Trennung erzwingt zusaetzlich das Backend, damit sie nicht allein an
 * dieser Weiche haengt.
 */
function SupportersPage(props) {
	if (mayOpenAdminPage(props.role, 'supporters')) return <AdminSupporters />
	if ([TRoles.STUDENT, TRoles.TEACHER].includes(props.role)) return <SupportersList role={props.role} />

	return <Redirect to={TRoutes.DASHBOARD} />
}

SupportersPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(SupportersPage)
